import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  margin: 0 0 40px 0;
  background: #fff0e2;
  background-image: linear-gradient(#fff0e2 30%, #ffffff);

  .block {
    margin-bottom: 20px;
    .text-description {
      white-space: pre-wrap;
    }
  }

  .html-content {
    a {
      color: #1890ff;
    }
  }

  .text-title {
    margin-bottom: 10px;
  }

  .promocode-block {
    background-color: ${theme.white};
    width: fit-content;
    margin: auto;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid rgba(213, 212, 212, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;

    .promocode {
      width: 200px;
      padding: 8px 20px;
      border-radius: 8px;
      border: 2px dashed rgba(213, 212, 212, 1);
      margin-right: 15px;
      &.copied {
        border-color: ${theme.lightGreen};
      }
    }

    .copy {
      cursor: pointer;
    }
  }

  .image-block {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;

    img {
      /* max-height: 500px; */
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .button-collet-block {
    margin-bottom: 40px;
    button {
      width: 100%;
      &.green {
        background-color: ${theme.lightGreen} !important;
      }
      &.gray {
        background-color: ${theme.lightGray} !important;
      }
    }
  }

  .container .button-block {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    button {
      min-width: 250px;
      min-height: 45px;
    }
  }

  @media (max-width: ${breakpoint.md}) {
    margin: 0 0 30px 0;

    .image-block {
      margin-bottom: 20px;
    }

    .promocode-block {
      margin-bottom: 30px;
    }

    .button-block {
      margin-top: 40px;
    }
  }
`
